import type { MoneyAmount } from '@fire-calc/domain-ts';

/**
 * Format a `MoneyAmount` for plain Czech display — whole CZK, space
 * thousands separator.
 *
 *   `formatCzk(15_000_000)` → `"15 000 000 Kč"`
 */
export function formatCzk(amount: MoneyAmount): string {
  const str = String(Math.round(amount.value));
  let buf = '';
  for (let i = 0; i < str.length; i++) {
    if (i > 0 && (str.length - i) % 3 === 0) buf += ' ';
    buf += str[i];
  }
  return `${buf} Kč`;
}
